var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetInOnGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 53,
    viewBox: "0 0 180 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1680_7043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.333 52.54H6.66667C3.00167 52.54 0 49.6174 0 46.049V7.10258C0 3.53412 3.00167 0.611518 6.66667 0.611518H173.333C176.998 0.611518 180 3.53412 180 7.10258V46.049C180 49.6174 176.998 52.54 173.333 52.54Z",
    fill: "#20252B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.333 1.65171C176.42 1.65171 178.932 4.09722 178.932 7.10258V46.049C178.932 49.0543 176.42 51.4998 173.333 51.4998H6.66667C3.58 51.4998 1.06833 49.0543 1.06833 46.049V7.10258C1.06833 4.09722 3.58 1.65171 6.66667 1.65171H173.333ZM173.333 0.611518H6.66667C3.00167 0.611518 0 3.53412 0 7.10258V46.049C0 49.6174 3.00167 52.54 6.66667 52.54H173.333C176.998 52.54 180 49.6174 180 46.049V7.10258C180 3.53412 176.998 0.611518 173.333 0.611518Z",
    fill: "#A6A8AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1365 13.9103C63.1365 14.9943 62.8036 15.8624 62.1478 16.5099C61.3939 17.2775 60.4119 17.6637 59.2085 17.6637C58.0585 17.6637 57.0765 17.271 56.2709 16.4969C55.4637 15.7115 55.0609 14.7476 55.0609 13.5938C55.0609 12.44 55.4637 11.4761 56.2709 10.6972C57.0765 9.91664 58.0585 9.52393 59.2085 9.52393C59.7811 9.52393 60.327 9.63914 60.8479 9.85335C61.3672 10.0692 61.79 10.3613 62.0962 10.7215L61.4005 11.4063C60.8663 10.7913 60.1389 10.4878 59.2085 10.4878C58.3697 10.4878 57.6424 10.7735 57.0249 11.3495C56.4141 11.9272 56.1078 12.6753 56.1078 13.5938C56.1078 14.5123 56.4141 15.2669 57.0249 15.8446C57.6424 16.4142 58.3697 16.7063 59.2085 16.7063C60.099 16.7063 60.8479 16.4142 61.4388 15.8381C61.8283 15.4568 62.0496 14.931 62.1079 14.2592H59.2085V13.3212H63.0765C63.1231 13.524 63.1365 13.7204 63.1365 13.9103Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.273 10.658H65.6397V13.1246H68.9152V14.0625H65.6397V16.5291H69.273V17.4849H64.6111V9.70215H69.273V10.658Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6036 17.4849H72.575V10.658H70.3464V9.70215H75.8339V10.658H73.6036V17.4849Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8052 17.4849V9.70215H80.8321V17.4849H79.8052Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3841 17.4849H84.3639V10.658H82.127V9.70215H87.621V10.658H85.3841V17.4849Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.01 16.484C97.2228 17.271 96.2475 17.6637 95.0841 17.6637C93.914 17.6637 92.9387 17.271 92.1514 16.484C91.3659 15.6985 90.9747 14.7346 90.9747 13.5938C90.9747 12.453 91.3659 11.4891 92.1514 10.7037C92.9387 9.91664 93.914 9.52393 95.0841 9.52393C96.2408 9.52393 97.2161 9.91663 98.0034 10.7102C98.7956 11.5021 99.1868 12.4595 99.1868 13.5938C99.1868 14.7346 98.7956 15.6985 98.01 16.484ZM92.9121 15.8316C93.5046 16.4142 94.2253 16.7063 95.0841 16.7063C95.9362 16.7063 96.6636 16.4142 97.2494 15.8316C97.8403 15.249 98.1399 14.5009 98.1399 13.5938C98.1399 12.6867 97.8403 11.9386 97.2494 11.356C96.6636 10.7735 95.9362 10.4814 95.0841 10.4814C94.2253 10.4814 93.5046 10.7735 92.9121 11.356C92.3212 11.9386 92.0216 12.6867 92.0216 13.5938C92.0216 14.5009 92.3212 15.249 92.9121 15.8316Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.63 17.4849V9.70215H101.878L105.759 15.7551H105.804L105.759 14.2589V9.70215H106.786V17.4849H105.714L101.65 11.1334H101.605L101.65 12.6361V17.4849H100.63Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7218 28.8511C87.5944 28.8511 85.0396 31.1716 85.0396 34.3734C85.0396 37.5491 87.5944 39.894 90.7218 39.894C93.8558 39.894 96.4106 37.5491 96.4106 34.3734C96.4106 31.1716 93.8558 28.8511 90.7218 28.8511ZM90.7218 37.7195C89.0058 37.7195 87.5295 36.3385 87.5295 34.3734C87.5295 32.3822 89.0058 31.0256 90.7218 31.0256C92.4377 31.0256 93.9207 32.3822 93.9207 34.3734C93.9207 36.3385 92.4377 37.7195 90.7218 37.7195ZM78.3238 28.8511C75.1898 28.8511 72.6417 31.1716 72.6417 34.3734C72.6417 37.5491 75.1898 39.894 78.3238 39.894C81.4562 39.894 84.006 37.5491 84.006 34.3734C84.006 31.1716 81.4562 28.8511 78.3238 28.8511ZM78.3238 37.7195C76.6062 37.7195 75.1249 36.3385 75.1249 34.3734C75.1249 32.3822 76.6062 31.0256 78.3238 31.0256C80.0398 31.0256 81.5161 32.3822 81.5161 34.3734C81.5161 36.3385 80.0398 37.7195 78.3238 37.7195ZM63.5708 30.5436V32.8902H69.3179C69.1498 34.2014 68.7004 35.1653 68.0114 35.8371C67.1725 36.6485 65.866 37.5491 63.5708 37.5491C60.034 37.5491 57.2645 34.7661 57.2645 31.3177C57.2645 27.8693 60.034 25.0863 63.5708 25.0863C65.4832 25.0863 66.8746 25.8149 67.9015 26.7593L69.5975 25.1057C68.1612 23.7686 66.2505 22.7414 63.5708 22.7414C58.7208 22.7414 54.6448 26.589 54.6448 31.3177C54.6448 36.0464 58.7208 39.894 63.5708 39.894C66.1922 39.894 68.1612 39.0567 69.709 37.4858C71.2952 35.9393 71.7895 33.7648 71.7895 32.009C71.7895 31.4637 71.7429 30.9623 71.6597 30.5436H63.5708ZM123.898 32.3628C123.43 31.1278 121.987 28.8511 119.048 28.8511C116.135 28.8511 113.71 31.0889 113.71 34.3734C113.71 37.4664 116.11 39.894 119.327 39.894C121.929 39.894 123.43 38.3475 124.048 37.4469L122.117 36.1925C121.473 37.111 120.596 37.7195 119.327 37.7195C118.067 37.7195 117.164 37.1564 116.584 36.0464L124.159 32.9908L123.898 32.3628ZM116.175 34.2013C116.11 32.0723 117.871 30.9818 119.133 30.9818C120.121 30.9818 120.96 31.4637 121.24 32.1534L116.175 34.2013ZM110.019 39.5581H112.508V23.3304H110.019V39.5581ZM105.941 30.0811H105.858C105.298 29.4353 104.232 28.8511 102.88 28.8511C100.044 28.8511 97.4508 31.2787 97.4508 34.3912C97.4508 37.4858 100.044 39.894 102.88 39.894C104.232 39.894 105.298 39.3049 105.858 38.6396H105.941V39.4315C105.941 41.5427 104.784 42.6771 102.918 42.6771C101.397 42.6771 100.453 41.606 100.064 40.7054L97.8986 41.5866C98.5227 43.0503 100.175 44.8516 102.918 44.8516C105.838 44.8516 108.301 43.1769 108.301 39.1021V29.187H105.941V30.0811ZM103.093 37.7195C101.377 37.7195 99.9407 36.3191 99.9407 34.3912C99.9407 32.4455 101.377 31.0256 103.093 31.0256C104.784 31.0256 106.117 32.4455 106.117 34.3912C106.117 36.3191 104.784 37.7195 103.093 37.7195ZM135.555 23.3304H129.6V39.5581H132.083V33.4094H135.555C138.313 33.4094 141.018 31.4637 141.018 28.3691C141.018 25.2761 138.306 23.3304 135.555 23.3304ZM135.62 31.1522H132.083V25.5877H135.62C137.474 25.5877 138.533 27.0888 138.533 28.3691C138.533 29.6251 137.474 31.1522 135.62 31.1522ZM150.97 28.8203C149.176 28.8203 147.311 29.5927 146.543 31.3047L148.747 32.2053C149.221 31.3047 150.093 31.0126 151.015 31.0126C152.304 31.0126 153.61 31.7672 153.63 33.0995V33.2699C153.181 33.0167 152.219 32.6419 151.035 32.6419C148.662 32.6419 146.244 33.9157 146.244 36.2931C146.244 38.4676 148.188 39.868 150.373 39.868C152.044 39.868 152.966 39.1329 153.545 38.2777H153.63V39.5321H156.029V33.3072C156.029 30.43 153.825 28.8203 150.97 28.8203ZM150.671 37.713C149.859 37.713 148.727 37.3203 148.727 36.3385C148.727 35.0825 150.138 34.6005 151.36 34.6005C152.453 34.6005 152.966 34.8359 153.63 35.1458C153.435 36.6485 152.109 37.713 150.671 37.713ZM164.766 29.1756L161.912 36.2103H161.827L158.876 29.1756H156.198L160.632 39.0064L158.102 44.4767H160.697L167.529 29.1756H164.766ZM142.382 39.5581H144.872V23.3304H142.382V39.5581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8942 10.3983C13.5031 10.7975 13.2767 11.419 13.2767 12.2239V40.9339C13.2767 41.7388 13.5031 42.3603 13.8942 42.7595L13.9908 42.8472L30.4914 26.7656V26.3858L13.9908 10.3042L13.8942 10.3983Z",
    fill: "url(#paint0_linear_1680_7043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9854 32.1289L30.4913 26.7657V26.3859L35.9921 21.0227L36.1153 21.0925L42.6296 24.7064C44.4887 25.732 44.4887 27.4196 42.6296 28.4517L36.1153 32.0591L35.9854 32.1289Z",
    fill: "url(#paint1_linear_1680_7043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1152 32.0589L30.4913 26.5756L13.8942 42.7594C14.5116 43.3923 15.5186 43.4686 16.6637 42.8357L36.1152 32.0589Z",
    fill: "url(#paint2_linear_1680_7043)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1152 21.0924L16.6637 10.3156C15.5186 9.68919 14.5116 9.76546 13.8942 10.3983L30.4913 26.5757L36.1152 21.0924Z",
    fill: "url(#paint3_linear_1680_7043)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1680_7043",
    x1: 29.0263,
    y1: 41.2329,
    x2: 7.24616,
    y2: 18.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1680_7043",
    x1: 45.0505,
    y1: 26.574,
    x2: 12.8323,
    y2: 26.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1680_7043",
    x1: 33.0571,
    y1: 23.5947,
    x2: 3.52147,
    y2: -6.69824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1680_7043",
    x1: 9.71632,
    y1: 52.3112,
    x2: 22.9053,
    y2: 38.7841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1680_7043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 41.6,
    fill: "white",
    transform: "matrix(1.25 0 0 -1.25 0 52.54)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetInOnGooglePlay);
export default __webpack_public_path__ + "static/media/get-in-on-google-play.12900b269698dd38797f755197de39b6.svg";
export { ForwardRef as ReactComponent };